import DebouncedAsyncSelect from './DebouncedAsyncSelect';

export default DebouncedAsyncSelect;
